<template>

  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader :title="$t('PurchaseInstallments.PurchaseInstallments')"
                     :description="$t('PurchaseInstallments.FromHereYouCanControlThePurchasePremiums')"/>
         <indexTable :searchText="$t('PurchaseInstallments.SearchForAPremium')"
                     :emptyTableText="$t('PurchaseInstallments.ThereAreNoPurchasePremiums')"
                     :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
                     :buttonRole="$user.role.purchase_cheques_add"
                     :cloumns="[
                         {column: 'code',    title: $t('PurchaseInstallments.Premium') ,type: 'mainLink' , sort: true },
                         {column: 'client_type',    title: $t('PurchaseInstallments.supplierName') ,type: 'clintLink', sort: true},
                         {column: 'safe_id',    title:$t('PurchaseInstallments.Treasury'),      type: 'link', to:'safe', sort: true, link: true},
                         {column: 'created_date',    title: $t('PurchaseInstallments.RegistrationDate') ,type: 'text' , sort: true },
                         {column: 'date',    title: $t('PurchaseInstallments.paymentDate') ,type: 'text' , sort: true },
                         {column: 'description',    title: $t('PurchaseInstallments.AndThatIsAbout') ,type: 'text' , sort: true },
                         {column: 'cost',    title: $t('purchaseCheques.amount') ,type: 'text' , sort: true },
                         {column: 'payment_method_id',    title: $t('PurchaseInstallments.PaymentMethod') ,type: 'link', to:'paymentMethod', sort: true, link: false},
                         {column: 'stat',    title: $t('PurchaseInstallments.active') ,type: 'status', sort: true,  values: [
                           {title: $t('PurchaseInstallments.Waiting'), value: 0, color: 'info'},
                           {title: $t('PurchaseInstallments.driven'), value: 1, color: 'success'},
                         ]},
                         {column: 'options', title: $t('PurchaseInstallments.measures'), type: 'options', options: [
                             {name: 'show'},
                             {name: 'edit',   role: $user.admin || $user.role.purchase_cheques_edit},
                             {name: 'file'},
                             {name: 'pay',   role: $user.admin || $user.role.purchase_cheques_edit},
                             {name: 'delete', role: $user.admin || $user.role.purchase_cheques_delete},
                         ]}
                       ]"
                     :deleteText="{
                        attention: $t('allerts.Attention'),
                        areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
                        close: $t('allerts.close'),
                        confirm: $t('allerts.confirm'),
                        loading: $t('allerts.loading'),
                       }" />
      </div>
    </div>
  </div>

</template>
<script>
  import indexHeader from '../elements/index/indexHeader.vue'
  import indexTable from '../elements/index/indexTable.vue'

  export default {
    data() {
      return {
        path: '/purchaseInstallments',
      }
    },
    components: {
      indexHeader,
      indexTable
    }
  }

</script>
